var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShowWidget
    ? _c(
        "div",
        {
          staticClass: "checkout-delivery-widget",
          class: { "checkout-delivery-widget_adaptive": _vm.adaptive }
        },
        [
          _vm.isStub
            ? _c(
                "ui-notification",
                {
                  staticClass: "checkout-delivery-widget__stub",
                  attrs: { title: _vm.widgetData.title, color: "#FFB71B" }
                },
                [_vm._v("\n    " + _vm._s(_vm.widgetData.description) + "\n  ")]
              )
            : _c(
                "div",
                { staticClass: "checkout-delivery-widget__wrap" },
                [
                  _vm.loading
                    ? _c("ui-loader", {
                        staticClass: "checkout-delivery-widget__loader",
                        attrs: { size: "30" }
                      })
                    : [
                        _c(
                          "div",
                          {
                            staticClass: "checkout-delivery-widget__text",
                            class: {
                              "checkout-delivery-widget__text_only-title": !_vm
                                .widgetData.description
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "checkout-delivery-widget__title"
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.widgetData.title) +
                                    "\n        "
                                )
                              ]
                            ),
                            _c("br"),
                            _vm.widgetData.description
                              ? _c("span", [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.widgetData.description) +
                                      "\n        "
                                  )
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm.widgetData.action
                          ? _c("ui-button", {
                              staticClass: "checkout-delivery-widget__action",
                              attrs: {
                                text: _vm.widgetData.action.text,
                                wide: "",
                                secondary: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onClickAction(
                                    _vm.widgetData.action
                                  )
                                }
                              }
                            })
                          : _vm._e()
                      ]
                ],
                2
              )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }